import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'

const adapter = new LocalStorage(`gd-db`);
const db = low(adapter);

db
    .defaults({
        sys: {}
    })
    .write();

export default db



// WEBPACK FOOTER //
// ./src/libs/util.db.js